// Store contact details used across the site (footer, product page, home page)
export const STORE = {
    name: "Raano - The Men's Club",
    instagramHandle: 'raano.tmc',
    instagramUrl: 'https://www.instagram.com/raano.tmc/',
    whatsappNumber: '919081599514', // international format, no + or spaces (wa.me links)
    whatsappDisplay: '+91 90815 99514',
    mapsUrl: 'https://maps.app.goo.gl/2e5ew2sbjPunp5PE9',
    mapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3670.756316894878!2d70.0811897!3d23.0693938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3950b9cf137c9885%3A0xf28c456bc64b788d!2sRaano%20-The%20Men's%20Club!5e0!3m2!1sen!2sin!4v1790491940704!5m2!1sen!2sin"
};

export const whatsappLink = (message = '') =>
    `https://wa.me/${STORE.whatsappNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;

// Headlines laid over the home page banners, in order (hero slides use the carousel images from
// Admin → Banners; the two editorial banners use the mini banners). Edit freely.
export const HOME_COPY = {
    hero: [
        { title: 'New season essentials', cta: 'Shop now' },
        { title: 'The shirt edit', cta: 'Shop shirts' },
        { title: 'Built for weekends', cta: 'Shop now' },
    ],
    editorial: { title: 'Festive tailoring', cta: 'Shop suits & blazers', match: 'suit' },
    newThisWeek: { title: 'New this week' },
};
